export default class DomainModel {
  constructor (data) {
    this.id = data.id
    this.name = data.name
    this.dtype = data.dtype
    this.description = data.description
    this.institution = data.institution ? data.institution : null
  }
}
